import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next' //语言包

import { Tag, Badge, Tooltip, Space, Typography, Button } from 'antd'
import {
    CommandStatusTagWrapper,
    DeviceStatusTagWrapper,
    WithIconTagWrapper,
    TextTagWrapper,
    AlarmTypeTagWrapper,
    PsStatusTagWrapper,
    TotalSystemTagWrapper,
    SubSystemTagWrapper,
    BlockedTagWrapper,
    TagCsCard,
    TagCsEditingCard,
    TagCsAddingCard,
    TagCsWaitingCard,
    TagCsSyncingCard,
    TagCsNormalCard,
    TagCsTimeoutCard,
    TagCsErrorCard,
    TagDsCard,
    TagDsDeviceOfflineCard,
    TagDsFailureCard,
    TagDsShutdownCard,
    TagDsNormalCard,
    TagAtCard,
    TagAtOfflineCard,
    TagAtFailureCard,
    TagAtDisconnectionCard,
    TagAtThresholdDiyCard,
    CommunicationStatusTagWrapper,
    ChargeStatusTagWrapper,
    LightStausTagWrapper,
    ProcessingStatusTagWrapper,
    RegulationResultTagWrapper,
    NoticeTypeTagWrapper
} from './style';

/* 命令状态图标组件 */
const CommandStatusTag = props => {
    const { t } = useTranslation();
    return (
        <>
            <CommandStatusTagWrapper>
                <Tag className={props.stateType}>
                    <span className='ant-tag-status-text'>{props.stateText}</span>
                </Tag>
            </CommandStatusTagWrapper>
        </>
    );
};

/* 设备状态图标组件 */
const DeviceStatusTag = ({ deviceFlag, tagType, tooltipText, onClick, isShow, showIcon = true }) => {
    const { t } = useTranslation();
    var iconsCss = React.useRef('Hide');
    var tagText = React.useRef('');
    switch (deviceFlag) {
        case 4:
        case '4':
            iconsCss.current = 'failure';
            tagText.current = t('All.Team.Tag.DeviceStatus.failure');
            break;
        case 3:
        case '3':
            iconsCss.current = 'shutDown';
            tagText.current = t('All.Team.Tag.DeviceStatus.shutDown');
            break;
        case 1:
        case '1':
            iconsCss.current = 'deviceOffline';
            tagText.current = t('All.Team.Tag.DeviceStatus.deviceOffline');
            break;
        default:
            iconsCss.current = 'normal';
            tagText.current = t('All.Team.Tag.DeviceStatus.normal');
            break;
    }

    const onlyBadge = (
        <Badge status={iconsCss.current} text={tagText.current} onClick={onClick} />
    );

    return (
        <DeviceStatusTagWrapper>
            <WithIconTagWrapper className={showIcon ? 'isShow' : 'isHide'}>
                {iconsCss.current !== 'normal' && tooltipText ? (
                    <Tooltip placement='top' title={tooltipText}>{onlyBadge}</Tooltip>
                ) : onlyBadge}
            </WithIconTagWrapper>
            <TextTagWrapper className={showIcon ? 'isHide' : 'isShow'}>
                <Tag className={iconsCss.current}>
                    <Typography.Text className='ant-tag-status-text textTag'>{tagText.current}</Typography.Text>
                </Tag>
            </TextTagWrapper>
        </DeviceStatusTagWrapper>
    );
};

const ProcessingStatusTag = ({ deviceFlag, tagType, tooltipText, onClick, isShow, showIcon = true }) => {
    const { t } = useTranslation();
    var iconsCss = React.useRef('Hide');
    var tagText = React.useRef('');

    switch (deviceFlag) {
        case 7:
          case '7':
          iconsCss.current = 'failure';
          tagText.current = t('All.Team.Tag.ProgressStatus.inProgress');
          break;
        case 8:
          case '8':
          iconsCss.current = 'commInterruption';
          tagText.current = t('All.Team.Tag.ProgressStatus.inProgress');
          break;
        case 9:
          case '9':
          iconsCss.current = 'deviceOffline';
          tagText.current = t('All.Team.Tag.ProgressStatus.inProgress');
          break;
        default:
            iconsCss.current = 'failure';
            tagText.current = t('All.Team.Tag.DeviceStatus.failure');
            break;
    }

    const onlyBadge = (
        <Badge status={iconsCss.current} text={tagText.current} onClick={onClick} />
    );

    return (
        <ProcessingStatusTagWrapper>
            <WithIconTagWrapper className={showIcon ? 'isShow' : 'isHide'}>
                {iconsCss.current !== 'normal' && tooltipText ? (
                    <Tooltip placement='top' title={tooltipText}>{onlyBadge}</Tooltip>
                ) : onlyBadge}
            </WithIconTagWrapper>
            <TextTagWrapper className={showIcon ? 'isHide' : 'isShow'}>
                <Tag className={iconsCss.current}>
                    <Typography.Text className='ant-tag-status-text textTag'>{tagText.current}</Typography.Text>
                </Tag>
            </TextTagWrapper>
        </ProcessingStatusTagWrapper>
    );
}

/* 报警类型图标组件 */
const AlarmTypeTag = props => {
    const { t } = useTranslation();
    return (
        <>
            <AlarmTypeTagWrapper className={props.tagType}>
                <Badge status={props.statusType} text={props.statusText} onClick={props.onClick} />
            </AlarmTypeTagWrapper>
        </>
    );
};

/* 命令状态打组帮助卡片(Cs=CommandStatus) */
const CsTagsTeam = props => {
    const { t } = useTranslation();
    return (
        <>
            <TagCsCard>
                <Space direction='vertical'>
                    {/* <Divider>{t('All.Note.SyncHelp.commandStatusTag')}</Divider> */}
                    <TagCsEditingCard>
                        <Space>
                            <CommandStatusTag stateType='tag-editing' stateText={t('All.Team.Tag.CommandStatus.editing')} />
                            <Typography.Text>
                                <Space direction='vertical' size={2}>
                                    {/* <span className='textTag'>{t('All.Team.Tag.CommandStatus.editing')}</span> */}
                                    <span className='textNote'>{t('All.Note.CsTag.editingDeviceInformation')}</span>
                                </Space>
                            </Typography.Text>
                        </Space>
                    </TagCsEditingCard>
                    <TagCsAddingCard>
                        <Space>
                            <CommandStatusTag stateType='tag-adding' stateText={t('All.Team.Tag.CommandStatus.adding')} />
                            <Typography.Text>
                                <Space direction='vertical' size={2}>
                                    {/* <span className='textTag'>{t('All.Team.Tag.CommandStatus.adding')}</span> */}
                                    <span className='textNote'>{t('All.Note.CsTag.addingDeviceInformation')}</span>
                                </Space>
                            </Typography.Text>
                        </Space>
                    </TagCsAddingCard>
                    <TagCsWaitingCard>
                        <Space>
                            <CommandStatusTag stateType='tag-waiting' stateText={t('All.Team.Tag.CommandStatus.waiting')} />
                            <Typography.Text>
                                <Space direction='vertical' size={2}>
                                    {/* <span className='textTag'>{t('All.Team.Tag.CommandStatus.waiting')}</span> */}
                                    <span className='textNote'>{t('All.Note.CsTag.waitingDeviceInformation')}</span>
                                </Space>
                            </Typography.Text>
                        </Space>
                    </TagCsWaitingCard>
                    <TagCsSyncingCard>
                        <Space>
                            <CommandStatusTag stateType='tag-syncing' stateText={t('All.Team.Tag.CommandStatus.syncing')} />
                            <Typography.Text>
                                <Space direction='vertical' size={2}>
                                    {/* <span className='textTag'>{t('All.Team.Tag.CommandStatus.syncing')}</span> */}
                                    <span className='textNote'>{t('All.Note.CsTag.syncingDeviceInformation')}</span>
                                </Space>
                            </Typography.Text>
                        </Space>
                    </TagCsSyncingCard>
                    <TagCsNormalCard>
                        <Space>
                            <CommandStatusTag stateType='tag-normal' stateText={t('All.Team.Tag.CommandStatus.normal')} />
                            <Typography.Text>
                                <Space direction='vertical' size={2}>
                                    {/* <span className='textTag'>{t('All.Team.Tag.CommandStatus.normal')}</span> */}
                                    <span className='textNote'>{t('All.Note.CsTag.syncSuccessful')}</span>
                                </Space>
                            </Typography.Text>
                        </Space>
                    </TagCsNormalCard>
                    <TagCsTimeoutCard>
                        <Space>
                            <CommandStatusTag stateType='tag-timeout' stateText={t('All.Team.Tag.CommandStatus.timeout')} />
                            <Typography.Text>
                                <Space direction='vertical' size={2}>
                                    {/* <span className='textTag'>{t('All.Team.Tag.CommandStatus.timeout')}</span> */}
                                    <span className='textNote'>{t('All.Note.CsTag.syncTimeout')}</span>
                                </Space>
                            </Typography.Text>
                        </Space>
                    </TagCsTimeoutCard>
                    <TagCsErrorCard>
                        <Space>
                            <CommandStatusTag stateType='tag-error' stateText={t('All.Team.Tag.CommandStatus.error')} />
                            <Typography.Text>
                                <Space direction='vertical' size={2}>
                                    {/* <span className='textTag'>{t('All.Team.Tag.CommandStatus.error')}</span> */}
                                    <span className='textNote'>{t('All.Note.CsTag.syncFailed')}</span>
                                </Space>
                            </Typography.Text>
                        </Space>
                    </TagCsErrorCard>
                </Space>
            </TagCsCard>
        </>
    );
};

/* 设备状态打组帮助卡片(Ds=DeviceStatus) */
const DsTagsTeam = props => {
    const { t } = useTranslation();
    return (
        <>
            <TagDsCard className='tagDsCard'>
                <Space direction='vertical'>
                    {/* <Divider>{t('All.Note.SyncHelp.deviceStatusTag')}</Divider> */}
                    <TagDsDeviceOfflineCard>
                        <Space>
                            <DeviceStatusTag deviceFlag={1} statusType='deviceOffline' statusText={t('All.Team.Tag.DeviceStatus.deviceOffline')} />
                            <Typography.Text>
                                <Space direction='vertical' size={2}>
                                    {/* <span className='textTag'>{t('All.Team.Tag.DeviceStatus.deviceOffline')}</span> */}
                                    <span className='textNote'>{t('All.Note.DsTag.offline')}</span>
                                </Space>
                            </Typography.Text>
                        </Space>
                    </TagDsDeviceOfflineCard>
                    <TagDsFailureCard>
                        <Space>
                            <DeviceStatusTag deviceFlag={4} statusType='failure' statusText={t('All.Team.Tag.DeviceStatus.failure')} />
                            <Typography.Text>
                                <Space direction='vertical' size={2}>
                                    {/* <span className='textTag'>{t('All.Team.Tag.DeviceStatus.failure')}</span> */}
                                    <span className='textNote'>{t('All.Note.DsTag.failure')}</span>
                                </Space>
                            </Typography.Text>
                        </Space>
                    </TagDsFailureCard>
                    <TagDsShutdownCard>
                        <Space>
                            <DeviceStatusTag deviceFlag={3} statusType='shutDown' statusText={t('All.Team.Tag.DeviceStatus.shutDown')} />
                            <Typography.Text>
                                <Space direction='vertical' size={2}>
                                    {/* <span className='textTag'>{t('All.Team.Tag.DeviceStatus.shutDown')}</span> */}
                                    <span className='textNote'>{t('All.Note.DsTag.shutDown')}</span>
                                </Space>
                            </Typography.Text>
                        </Space>
                    </TagDsShutdownCard>
                    <TagDsNormalCard>
                        <Space>
                            <DeviceStatusTag deviceFlag={0} statusType='normal' statusText={t('All.Team.Tag.DeviceStatus.normal')} />
                            <Typography.Text>
                                <Space direction='vertical' size={2}>
                                    {/* <span className='textTag'>{t('All.Team.Tag.DeviceStatus.normal')}</span> */}
                                    <span className='textNote'>{t('All.Note.DsTag.normal')}</span>
                                </Space>
                            </Typography.Text>
                        </Space>
                    </TagDsNormalCard>
                </Space>
            </TagDsCard>
        </>
    );
};

/* 报警类型打组帮助卡片(At=AlarmType)*/
const AtTagsTeam = props => {
    const { t } = useTranslation();
    return (
        <>
            <TagAtCard className='tagAtCard'>
                <Space direction='vertical'>
                    {/* <Divider>报警类型标签</Divider> */}
                    <TagAtOfflineCard>
                        <Space>
                            <AlarmTypeTag statusType='offline' statusText={t('All.Operation.Filter.AlarmType.offline')} />
                            <Typography.Text>
                                <Space direction='vertical' size={2}>
                                    {/* <span className='textTag'>{t('All.Team.Tag.AlarmType.deviceOffline')}</span> */}
                                    <span className='textNote'>{t('All.Note.AtTag.offline')}</span>
                                </Space>
                            </Typography.Text>
                        </Space>
                    </TagAtOfflineCard>
                    <TagAtFailureCard>
                        <Space>
                            <AlarmTypeTag statusType='failure' statusText={t('All.Operation.Filter.AlarmType.failure')} />
                            <Typography.Text>
                                <Space direction='vertical' size={2}>
                                    {/* <span className='textTag'>{t('All.Operation.Filter.AlarmType.failure')}</span> */}
                                    <span className='textNote'>{t('All.Note.AtTag.failure')}</span>
                                </Space>
                            </Typography.Text>
                        </Space>
                    </TagAtFailureCard>
                    <TagAtDisconnectionCard>
                        <Space>
                            <AlarmTypeTag statusType='commInterruption' statusText={t('All.Operation.Filter.AlarmType.commInterruption')} />
                            <Typography.Text>
                                <Space direction='vertical' size={2}>
                                    {/* <span className='textTag'>{t('All.Operation.Filter.AlarmType.commInterruption')}</span> */}
                                    <span className='textNote'>{t('All.Note.AtTag.commInterruption')}</span>
                                </Space>
                            </Typography.Text>
                        </Space>
                    </TagAtDisconnectionCard>
                    <TagAtThresholdDiyCard>
                        <Space>
                            <AlarmTypeTag statusType='thresholdAlarm' statusText={t('All.Operation.Filter.AlarmType.thresholdAlarm')} />
                            <Typography.Text>
                                <Space direction='vertical' size={2}>
                                    {/* <span className='textTag'>{t('All.Operation.Filter.AlarmType.thresholdAlarm')}</span> */}
                                    <span className='textNote'>{t('All.Note.AtTag.thresholdAlarm')}</span>
                                </Space>
                            </Typography.Text>
                        </Space>
                    </TagAtThresholdDiyCard>
                </Space>
            </TagAtCard>
        </>
    );
};

/* 电站状态图标组件 */
const PsStatusTag = props => {
    const { t } = useTranslation();
    return (
        <>
            <PsStatusTagWrapper>
                <Badge status={props.statusType} text={props.statusText} onClick={props.onClick} />
            </PsStatusTagWrapper>
        </>
    );
};

/* 总系统状态图标组件 */
const TotalSystemTag = props => {
    const { t } = useTranslation();
    return (
        <>
            <TotalSystemTagWrapper>
                <Badge status={props.statusType} text={props.statusText} onClick={props.onClick} />
            </TotalSystemTagWrapper>
        </>
    );
};

/* 子系统状态图标组件 */
const SubSystemTag = props => {
    const { t } = useTranslation();
    return (
        <>
            <SubSystemTagWrapper>
                <Badge status={props.statusType} text={props.statusText} onClick={props.onClick} />
            </SubSystemTagWrapper>
        </>
    );
};

/* 已屏蔽状态图标组件 */
const BlockedTag = props => {
    const { t } = useTranslation();
    return (
        <>
            <BlockedTagWrapper>
                <Tooltip placement='top' title={props.tooltipText || t('All.Note.Tips.Tooltip.tip-blocked')}>
                    <Tag>
                        <span className='ant-tag-status-text'>{props.statusText || t('All.Team.Tag.blocked')}</span>
                    </Tag>
                </Tooltip>
            </BlockedTagWrapper>
        </>
    );
};

/* 连接状态图标组件 */
const ConnectionStatusTag = ({ deviceFlag }) => {
    const { t } = useTranslation();
    const stateType = React.useRef('');
    const stateText = React.useRef('');
    switch (deviceFlag) {
        case 0:
        case '0':
            stateType.current = 'connection-failure';
            stateText.current = t('All.Team.Tag.CommunicationStatus.failure');
            break;
        default:
            stateType.current = 'connection-success';
            stateText.current = t('All.Team.Tag.CommunicationStatus.normal');
            break;
    }
    return (
        <>
            <CommunicationStatusTagWrapper>
                <Tag className={stateType.current}>
                    <Typography.Text className='ant-tag-status-text'>{stateText.current}</Typography.Text>
                </Tag>
            </CommunicationStatusTagWrapper>
        </>
    );
};

/* 充放电状态图标组件 */
const ChargeStatusTag = ({ state }) => {
    const { t } = useTranslation();
    const stateType = React.useRef('');
    const stateText = React.useRef('');
    if (state === 1) {
        stateType.current = 'charging';
        stateText.current = t('All.Team.Tag.OperationStatus.charging');
    } else if (state === -0) {
        stateType.current = 'discharging';
        stateText.current = t('All.Team.Tag.OperationStatus.discharging');
    } else {
        stateType.current = '';
        stateText.current = '-';
    }
    return (
        <>
            <ChargeStatusTagWrapper>
                <Tag className={stateType.current}>
                    <Typography.Text className='ant-tag-status-text'>{stateText.current}</Typography.Text>
                </Tag>
            </ChargeStatusTagWrapper>
        </>
    );
};

/* 指示灯状态图标组件 */
const LightStausTag = ({ lightState = 1, lightName = '-' }) => {
    const lightText = React.useRef('');
    const lightStyle = React.useRef('');
    const { Text } = Typography;
    useEffect(() => {
        if (lightState === 1) {
            lightText.current = 'START';
            lightStyle.current = 'status-start';
        } else if (lightState === 0) {
            lightText.current = 'STOP';
            lightStyle.current = 'status-stop';
        } else {
            lightText.current = '-';
        }
    }, [lightState]);
    return (
        <>
            <LightStausTagWrapper>
                <Tag className={lightStyle.current}>
                    {lightText.current}
                </Tag>
                <Text>{lightName}</Text>
            </LightStausTagWrapper>
        </>
    );
};

/* 一调结果质量组件 */
const RegulationResultTag = ({ statusText, stateType, labelText }) => {
    return (
        <RegulationResultTagWrapper>
            {statusText && (
                <Tag className={stateType} style={{ visibility: statusText ? 'isShow' : 'isHide' }}>
                    <Typography.Text className='ant-tag-status-text'>{statusText}</Typography.Text>
                </Tag>
            )}
            <Typography.Text>{labelText}</Typography.Text>
        </RegulationResultTagWrapper>
    );
};

/* 公告通知类型组件 */
const NoticeTypeTag = ({ level = 1, createtime }) => {
  const { t } = useTranslation();
  const config = {
    1: {
      color: 'var(--general)',
      text : t('All.Team.Tag.NoticeType.general'),
    },
    2: {
      color: 'var(--important)',
      text : t('All.Team.Tag.NoticeType.important'),
    },
    3: {
      color: 'var(--urgent)',
      text : t('All.Team.Tag.NoticeType.urgent'),
    },
  };
  const { color, text } = config[level] || config[1];
  const isNew = createtime && new Date() - new Date(createtime) <= 90 * 24 * 60 * 60 * 1000;
  return (
    <NoticeTypeTagWrapper>
        <Tag style={{ backgroundColor: color }}> {text} </Tag>
        {isNew && ( <span className='ant-tag-status-text'> {t('All.Team.Tag.NoticeType.new')} </span> )}
    </NoticeTypeTagWrapper> 
  );
};

export {
    CommandStatusTag,
    DeviceStatusTag,
    AlarmTypeTag,
    PsStatusTag,
    TotalSystemTag,
    SubSystemTag,
    BlockedTag,
    CsTagsTeam,
    DsTagsTeam,
    AtTagsTeam,
    ConnectionStatusTag,
    ChargeStatusTag,
    LightStausTag,
    ProcessingStatusTag,
    RegulationResultTag,
    NoticeTypeTag
};